<p-card [header]="'Odabir odredišne jedinice za jedinicu ' + selectedParentName">
    <ng-container *ngIf="isBatchMode">
        <p class="batch-subtitle">Premjesti {{selectedParentIds.length}} jedinica gradiva</p>
    </ng-container>
    <!--<ng-container>
        <ntap-dynamic compId="ntapFilterView"></ntap-dynamic>
    </ng-container>-->
    <!--<p-toolbar>
        <div class="p-toolbar-group-left">
            <ntap-dynamic [compId]="tableToolbarCompId"></ntap-dynamic>
        </div>
    </p-toolbar>-->
        <ng-container *ngIf="files1$ | async as files">
            <div class="search-container">
                <span class="p-input-icon-right">
                    <i *ngIf="searchQuery" class="pi pi-times" (click)="clearSearch()"></i>
                    <input pInputText
                           [(ngModel)]="searchQuery"
                           [ngModelOptions]="{standalone: true}"
                           placeholder="Arhivska oznaka"
                           [maxlength]="100"
                           (keydown.enter)="performSearch()" />
                </span>
                <button pButton label="Pretraži"
                        [disabled]="isSearching || !searchQuery.trim()"
                        (click)="performSearch()"></button>
            </div>

            <p-progressSpinner *ngIf="isSearching" styleClass="search-spinner" [style]="{width: '2rem', height: '2rem'}"></p-progressSpinner>

            <div *ngIf="showSearchResults && searchResults.length > 0" class="search-results-tree">
              <div *ngFor="let item of searchResults"
                   class="hierarchy-item"
                   [ngClass]="{'disabled': isItemDisabled(item), 'selected': selectedNewParentJedinicaId === item['en~jedinica_gradiva~id']}"
                   [title]="item['en~jedinica_gradiva~arhivska_oznaka'] + ' ' + item['en~jedinica_gradiva~glavni_naziv']"
                   (click)="onSearchResultSelect(item)">
                {{item['en~jedinica_gradiva~arhivska_oznaka']}} {{item['en~jedinica_gradiva~glavni_naziv']}} ({{getRazinaLabel(item['en~jedinica_gradiva~razina'])}})
              </div>
            </div>

            <div *ngIf="showSearchResults && searchResults.length === 0 && !isSearching" class="no-results">Nema pronađenih rezultata</div>

            <div *ngIf="searchError" class="search-error p-error">{{searchError}}</div>

            <div *ngIf="validationError" class="validation-error">{{validationError}}</div>

            <p-tree *ngIf="!showSearchResults" [propagateSelectionUp]="false" [value]="files" selectionMode="single" [(selection)]="selectedFiles"
                (onNodeExpand)="nodeExpand($event)"
                (onNodeCollapse)="nodeCollapse($event)" [loading]="(loadingState$ | async) ?? true" (onNodeSelect)="onNodeSelect($event)">

                <ng-template let-node pTemplate="default">
                    <div>
                        <ng-container ntapListItemProvider [item]="node.data" [listIndex]="node.id">
                            <div class="flex flex-wrap align-items-center justify-content-center">
                                <span [class]="node.lockedIconClass"></span>
                                <span class="m-2 vertical-align-middle">{{node.label}}</span>
                                <div *ngIf="node.selectable">
                                    <ntap-dynamic [compId]="tableToolbarCompId1"></ntap-dynamic>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                </ng-template>
                <ng-template let-node pTemplate="url">
    
                    <button pButton class="custom-button" pRipple type="button" label="Učitaj više"
                        class="mr-2 p-button-info" pTooltip="Učitaj više rezultata." icon="pi pi-arrow-down"
                        (click)="this.loadMore(node)"></button>

                </ng-template>
            </p-tree>
            <div class="oznaka-container">
                <form [formGroup]="fg">
                    <ng-container *ngIf="redoslijedFormControl && newArhivskaOznakaPrefix">
                        <p-messages [value]="warnMessage" [enableService]="false" [closable]="false"></p-messages>
                        <ng-container *ngIf="!isBatchMode">
                            <label>Nova arhivska
                                oznaka:</label>&nbsp;<span>{{newArhivskaOznakaPrefix}}</span>-<p-inputNumber
                                (onInput)="redoslijedOznakaChange($event)" [formControl]="redoslijedFormControl" useGrouping="false"></p-inputNumber>
                        </ng-container>
                    </ng-container>
                </form>
                
                <ng-container *ngIf="actions$ | async as actions">
                    <ng-container *ngFor="let action of actions | actionTarget: 'ITEM_DIALOG'">
                        <div class="mt-3">
                            <p-button label="Odustani" (onClick)="close()" class="mr-2"></p-button>
                            <ntap-dynamic [compId]="getActionComponentId(action)" [inputParam]="action"></ntap-dynamic>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
    </ng-container>
    <p-toast [preventOpenDuplicates]="true"></p-toast>
</p-card>